(() => {
  const initSticky = (productInfo) => {
    if (!productInfo || productInfo.dataset.stickyAtcInitialized === 'true') return;

    const sticky = productInfo.querySelector('[data-sticky-atc]');
    const trigger = productInfo.querySelector('[data-sticky-trigger]');
    if (!sticky || !trigger) return;

    productInfo.dataset.stickyAtcInitialized = 'true';
    productInfo.setAttribute('data-sticky-atc-enabled', 'true');

    const mainVariantInput = productInfo.querySelector(`#product-form-${productInfo.dataset.section} input[name='id']`);
    const stickyVariantInput = sticky.querySelector('[data-sticky-variant-id]');
    const priceTarget = sticky.querySelector('[data-sticky-price]');
    const priceSource = productInfo.querySelector(`#price-${productInfo.dataset.section}`);

    const syncVariant = () => {
      if (!mainVariantInput || !stickyVariantInput) return;
      stickyVariantInput.value = mainVariantInput.value;
      stickyVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const syncPrice = () => {
      if (!priceSource || !priceTarget) return;
      priceTarget.innerHTML = priceSource.innerHTML;
    };

    const updateStickyHeight = () => {
      const height = sticky.offsetHeight || 0;
      productInfo.style.setProperty('--sticky-atc-height', `${height}px`);
    };

    const setHidden = (isHidden) => {
      sticky.classList.toggle('is-hidden', isHidden);
    };

    const shouldShowSticky = () => {
      if (window.innerWidth <= 749) {
        return window.scrollY > 120;
      }
      return true;
    };

    const showSticky = () => {
      if (!shouldShowSticky()) return;
      productInfo.setAttribute('data-sticky-atc-visible', 'true');
      sticky.classList.add('is-visible');
      setHidden(false);
      updateStickyHeight();
    };

    const hideSticky = () => {
  productInfo.removeAttribute('data-sticky-atc-visible');
  sticky.classList.remove('is-visible');
  productInfo.style.setProperty('--sticky-atc-height', `0px`);
};

    syncVariant();
    syncPrice();
    updateStickyHeight();

    if (mainVariantInput) {
      mainVariantInput.addEventListener('change', () => {
        syncVariant();
        syncPrice();
      });
    }

    if (priceSource) {
      const observer = new MutationObserver(syncPrice);
      observer.observe(priceSource, { childList: true, subtree: true });
    }

    const scrollLink = sticky.querySelector('[data-sticky-scroll]');
    const stickySelects = Array.from(sticky.querySelectorAll('[data-sticky-option-select]'));
    if (scrollLink) {
      scrollLink.addEventListener('click', (event) => {
        const targetId = scrollLink.getAttribute('href');
        const target = targetId ? document.querySelector(targetId) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const updateMainOption = (optionName, optionValue) => {
      const variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) return;

      const select = variantSelects.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
      if (select) {
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const radio = variantSelects.querySelector(
        `input[type="radio"][name="options[${CSS.escape(optionName)}]"][value="${CSS.escape(optionValue)}"]`
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const syncStickySelectsFromMain = () => {
      if (!stickySelects.length) return;
      const variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) return;

      stickySelects.forEach((stickySelect) => {
        const optionName = stickySelect.getAttribute('data-option-name');
        if (!optionName) return;

        const mainSelect = variantSelects.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
        if (mainSelect) {
          stickySelect.value = mainSelect.value;
          return;
        }

        const mainChecked = variantSelects.querySelector(
          `input[type="radio"][name="options[${CSS.escape(optionName)}]"]:checked`
        );
        if (mainChecked) {
          stickySelect.value = mainChecked.value;
        }
      });
    };

    stickySelects.forEach((stickySelect) => {
      stickySelect.addEventListener('change', () => {
        const optionName = stickySelect.getAttribute('data-option-name');
        if (!optionName) return;
        updateStickyVariantFromOptions();
        updateMainOption(optionName, stickySelect.value);
        // main picker updates variant asynchronously; re-sync after change
        setTimeout(() => {
          syncVariant();
          syncPrice();
          syncStickySelectsFromMain();
          updateStickyVariantFromOptions();
        }, 0);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting || !shouldShowSticky()) {
              hideSticky();
              return;
            }
            showSticky();
          });
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      observer.observe(trigger);
    } else {
      const onScroll = () => {
        const rect = trigger.getBoundingClientRect();
        if (rect.bottom < 0 && shouldShowSticky()) {
          showSticky();
        } else {
          hideSticky();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const updateFromDrawer = () => {
  const drawerOpen =
    cartDrawer?.classList.contains('active') ||
    cartDrawer?.classList.contains('animate') ||
    document.body.classList.contains('overflow-hidden');
  setHidden(!!drawerOpen);
  if (drawerOpen) {
    productInfo.removeAttribute('data-sticky-atc-visible');
    productInfo.style.setProperty('--sticky-atc-height', `0px`);
  }
};
    if (cartDrawer) {
      const drawerObserver = new MutationObserver(updateFromDrawer);
      drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    const bodyObserver = new MutationObserver(updateFromDrawer);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    updateFromDrawer();

    const stickyForm = sticky.querySelector('form[action*="/cart/add"]');
    let productData = null;
    fetch(`${productInfo.dataset.url}.js`)
      .then((res) => res.json())
      .then((data) => {
        productData = data;
        updateStickyVariantFromOptions();
      })
      .catch(() => null);

    const getSelectedOptions = () => {
      const optionsByName = {};
      const optionsByPosition = {};
      if (stickySelects.length) {
        stickySelects.forEach((select) => {
          const name = select.getAttribute('data-option-name');
          if (name) optionsByName[name] = select.value;
          const position = Number(select.getAttribute('data-option-position'));
          if (position) optionsByPosition[position] = select.value;
        });
      } else {
        const variantSelects = productInfo.querySelector('variant-selects');
        if (!variantSelects) return { optionsByName, optionsByPosition };
        const selects = variantSelects.querySelectorAll('select[name^="options["]');
        selects.forEach((select) => {
          const name = select.name.replace(/^options\[|\]$/g, '');
          optionsByName[name] = select.value;
        });
        const radios = variantSelects.querySelectorAll('input[type="radio"][name^="options["]:checked');
        radios.forEach((radio) => {
          const name = radio.name.replace(/^options\[|\]$/g, '');
          optionsByName[name] = radio.value;
        });
      }
      return { optionsByName, optionsByPosition };
    };

    const findVariantId = () => {
      if (!productData || !productData.variants) return null;
      const selected = getSelectedOptions();
      const optionNames = productData.options || [];
      const variant = productData.variants.find((v) => {
        if (Object.keys(selected.optionsByPosition).length) {
          return optionNames.every((_, idx) => {
            const selectedValue = selected.optionsByPosition[idx + 1];
            const variantValue = v[`option${idx + 1}`];
            return selectedValue ? selectedValue === variantValue : true;
          });
        }
        return optionNames.every((optName, idx) => {
          const selectedValue = selected.optionsByName[optName];
          const variantValue = v[`option${idx + 1}`];
          return selectedValue ? selectedValue === variantValue : true;
        });
      });
      return variant ? variant.id : null;
    };

    const updateStickyVariantFromOptions = () => {
      const variantId = findVariantId();
      if (variantId && stickyVariantInput) {
        stickyVariantInput.value = variantId;
        stickyVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        syncVariant();
      }
    };

    if (stickyForm) {
      stickyForm.addEventListener(
        'submit',
        () => {
          setHidden(true);
          updateStickyVariantFromOptions();
        },
        { capture: true }
      );
    }

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId !== productInfo.dataset.section) return;
        syncVariant();
        syncPrice();
        syncStickySelectsFromMain();
        updateStickyVariantFromOptions();
      });
    }

    syncStickySelectsFromMain();
  };

  const initAll = () => {
    document.querySelectorAll("product-info[id^='MainProduct-']").forEach(initSticky);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', (event) => {
    const productInfo =
      event.target?.closest?.("product-info[id^='MainProduct-']") || event.target;
    initSticky(productInfo);
  });
})();
